import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AdminAuthProvider, LojistaAuthProvider, useAdminAuth, useLojistaAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import QuemSomos from "@/pages/QuemSomos";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/components/layouts/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminUnidades from "@/pages/AdminUnidades";
import AdminLiquidez from "@/pages/AdminLiquidez";
import AdminUnidadeHistorico from "@/pages/AdminUnidadeHistorico";
import AdminContratos from "@/pages/AdminContratos";
import AdminFinanceiro from "@/pages/AdminFinanceiro";
import AdminExtrato from "@/pages/AdminExtrato";
import AdminAcordos from "@/pages/AdminAcordos";
import AdminDP from "@/pages/AdminDP";
import AdminDocumentos from "@/pages/AdminDocumentos";
import AdminObras from "@/pages/AdminObras";
import AdminWhatsApp from "@/pages/AdminWhatsApp";
import AdminConfig from "@/pages/AdminConfig";

import LojistaLogin from "@/pages/LojistaLogin";
import LojistaLayout from "@/components/layouts/LojistaLayout";
import LojistaDashboard from "@/pages/LojistaDashboard";
import LojistaContrato from "@/pages/LojistaContrato";
import LojistaObras from "@/pages/LojistaObras";
import LojistaRegimento from "@/pages/LojistaRegimento";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="text-center">
        <div className="w-12 h-12 bg-foreground text-background flex items-center justify-center font-heading font-black mx-auto mb-4 animate-pulse">VM</div>
        <div className="label-tag">Carregando...</div>
      </div>
    </div>
  );
}

function AdminGuard() {
  const { admin } = useAdminAuth();
  if (admin === null) return <LoadingScreen />;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return <AdminLayout />;
}

function LojistaGuard() {
  const { lojista } = useLojistaAuth();
  if (lojista === null) return <LoadingScreen />;
  if (!lojista) return <Navigate to="/lojista/login" replace />;
  return <LojistaLayout />;
}

function AdminScope() {
  return (
    <AdminAuthProvider>
      <Outlet />
    </AdminAuthProvider>
  );
}

function LojistaScope() {
  return (
    <LojistaAuthProvider>
      <Outlet />
    </LojistaAuthProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quem-somos" element={<QuemSomos />} />

          {/* Admin */}
          <Route element={<AdminScope />}>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminGuard />}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="unidades" element={<AdminUnidades />} />
              <Route path="unidades/:id/historico" element={<AdminUnidadeHistorico />} />
              <Route path="liquidez" element={<AdminLiquidez />} />
              <Route path="historico" element={<AdminLiquidez />} />
              <Route path="contratos" element={<AdminContratos />} />
              <Route path="financeiro" element={<AdminFinanceiro />} />
              <Route path="extrato" element={<AdminExtrato />} />
              <Route path="acordos" element={<AdminAcordos />} />
              <Route path="dp" element={<AdminDP />} />
              <Route path="documentos" element={<AdminDocumentos />} />
              <Route path="obras" element={<AdminObras />} />
              <Route path="whatsapp" element={<AdminWhatsApp />} />
              <Route path="config" element={<AdminConfig />} />
            </Route>
          </Route>

          {/* Lojista */}
          <Route element={<LojistaScope />}>
            <Route path="/lojista/login" element={<LojistaLogin />} />
            <Route path="/lojista" element={<LojistaGuard />}>
              <Route index element={<Navigate to="/lojista/dashboard" replace />} />
              <Route path="dashboard" element={<LojistaDashboard />} />
              <Route path="meu-contrato" element={<LojistaContrato />} />
              <Route path="obras" element={<LojistaObras />} />
              <Route path="regimento" element={<LojistaRegimento />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
